import React from "react";

import { DMRScreen, PaymentsControlScreen } from "@/screens/FinStatements/MoneywatchReports";
import { DefaultLayout } from "@components/Layouts";
import ReportCloud from "@screens/FinStatements/Cloud";
import DeveloperReceipts from "@screens/FinStatements/DeveloperReceipts";
import Documents from "@screens/FinStatements/Documents";
import Merchants from "@screens/FinStatements/Merchants";
import Month from "@screens/FinStatements/Month";
import Royalty from "@screens/FinStatements/Royalty";
import NotFound from "@screens/NotFound";

export default function FinStatementsScreen({ screen }) {
    let width = null;
    let body = "";
    switch (screen) {
        case "month":
            width = 75;
            body = <Month />;
            break;
        case "payments_control":
            width = 75;
            body = <PaymentsControlScreen />;
            break;
        case "dmr":
            width = 75;
            body = <DMRScreen />;
            break;
        case "documents":
            body = <Documents />;
            break;
        case "royalty":
            body = <Royalty />;
            break;
        case "report_cloud":
            body = <ReportCloud />;
            break;
        case "developer_receipts":
            body = <DeveloperReceipts />;
            break;
        case "merchants":
            body = <Merchants />;
            break;
        default:
            break;
    }

    if (!body) {
        return <NotFound />;
    }

    return <DefaultLayout width={width}>{body}</DefaultLayout>;
}
